export default {"src":"https://fishbrain.com/_next/static/media/louisiana.c6486d47.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};